// extracted by mini-css-extract-plugin
module.exports = {"container":"_2X9gh","image":"_3YyJH"};